import React from 'react';

interface FilterContainerProps {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  filterRef?: React.RefObject<HTMLDivElement>;
}

export const FilterContainer: React.FC<FilterContainerProps> = ({
  children,
  onClick,
  filterRef,
}) => {
  return (
    <div
      ref={filterRef}
      className={`file-list-filters-modal absolute left-12 z-[1000] mt-2.5 w-72 animate-fadeIn overflow-hidden rounded-lg bg-white shadow-lg dark:bg-[#1c1c1f]`}
      onClick={onClick}
    >
      <div className="select-none divide-y divide-gray-100 dark:divide-gray-800">
        {children}
      </div>
    </div>
  );
};
